import type { DidYouKnowSectionProps } from './DidYouKnowSection.types';
import { Card, CardContent } from '@monksflow/monks-ui';
import { SectionHeader } from '@/shared/ui/SectionHeader';
import { useTranslation } from 'react-i18next';
export const DidYouKnowSection = ({ persona }: DidYouKnowSectionProps) => {
  const { t } = useTranslation('audiences');

  const didYouKnow = persona.insightsData?.data.didYouKnow || [];

  if (didYouKnow.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-6">
      <SectionHeader title={t('audienceFlowWidget.didYouKnowSection.didYouKnow')} />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {didYouKnow.map((item) => (
          <Card
            key={`${item.stat}-${item.caption}`}
            variant="outline"
            className="flex flex-col shadow-none border-border-light"
          >
            <CardContent>
              <span className="type-display-sm text-foreground mb-2 block">{item.stat}%</span>
              <p className="type-body-md text-foreground-alt">{item.caption}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
